import { Text, VStack, Icon, Flex } from '@chakra-ui/react';
import React from 'react';
import { formatNumberWithCommas } from '@utils';


const StatusCard = ({
    status,
    onClick = () => {},
    isActive = false,
    activeColor = 'blue.400',
    icon,
    description
}) => (
    <VStack
        minWidth="5rem"
        minHeight="5rem"
        p={2}
        bg={"black"}
        alignItems="stretch"
        justifyContent="center"
        border={isActive ? "1px solid" : "1px solid"}
        borderRadius="xl"
        borderColor={isActive ? activeColor : "whiteAlpha.300"}
        cursor={onClick ? "pointer" : "default"}
        _hover={{ bgColor: isActive ? activeColor : "#414141" }}
        boxShadow={isActive ? "0px 4px 10px rgba(0, 0, 0, 0.2)" : "none"}
        spacing={0}
        onClick={() => onClick(status.status)}
    >
        <Flex justify="space-between" align="center" mb={1}>
            <Text fontSize="2xl" fontWeight="bold">
                {formatNumberWithCommas(status.count, 0)}
            </Text>
            {icon && (
              <Icon as={icon} w={5} h={5} color={activeColor} />
            )}
        </Flex>
        <Text fontSize="xs">{status.title}</Text>
        {description && (
            <Text fontSize="xs" color="whiteAlpha.600" mt={1}>
                {description}
            </Text>
        )}
    </VStack>
);

export default StatusCard;